import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'docRef'
})
export class DocRefPipe implements PipeTransform {

  transform(ref: any, field: string): any {
    if (!ref) return null;
    return ref.get().then(doc => {
      if (doc.data() !== undefined) {
        return field ? doc.data()[field] : doc.data()
      } else {
        return null
      }
    });
  }
}
